export const text = {
  name: "Name",
  email: "Email",
  phone: "Phone",
  country: "Country",
  address: "Address",
  zipCode: "Zip Code",
  state: "State",
  city: "City",
  age: "Age",
  gender: "Gender",
  language: "Preferred Language",
  type: "Plan Type",
  created: "Created On",
  title: "Users",
  editUser: "Edit User",
  subscriberType: "Subscriber Type",
  additional: "Additional",
  sendNotification: "Send Notification",
  notificationMessage: "Notification Message",
  userManageTitle: "User Management",
  youWantToActive: "you want to activate this user?",
  youWantToDeActive: "you want to deactivate this user?",
  userManagement: "User Management",
  userDetails: "User Details",
  planExpiryDate: "Plan Expiry Date",
  planStartDate: "Plan Start Date",
  transactionDetails: "Transaction Details",
  shortDetails: "Short Details",
  searchByUser: "First Name and Last Name Email, Phone Number.",
};
